<template>
	<div id="language_setting">
        <section class="menu_ctrl">
            <span class="text">{{$t('__language_setting.top_hint')}}</span>
        </section>
        <div v-if="init_items.length > 0" class="language_treeview">
            <TreeView
                :init_items='init_items'
                :checked_selectors='checked_selectors'
                :init_opened_layers='init_opened_layers'
                :check_function='change_language'
            ></TreeView>
        </div>
    </div>
</template>

<script>
    import i18n from '@/i18n/i18n'
    import { mapMutations, mapState } from "vuex";
    import TreeView from '@/components/tree_view.vue'
	export default {
        name: 'language_setting',
        
		components: {
            TreeView
        },

        data() {
            return {
                init_opened_layers: [],
                init_items: [],
                checked_selectors: {},
                init_checked_value: '',
            }
        },

        computed: {
            ...mapState([
                'language'
            ])
        },
    
        created() {
            this.initialize()
        },

        methods: {
            ...mapMutations([
                'set_language'
            ]),

            initialize() {
                try {
                    this._construct_setting_data();
                } catch (err) {
                    console.error(err)
                }
            },

            _construct_setting_data() {
                const LANGUAGE_OPTIONS = [
                    { name: '中文',  id: 'language_tw', value: 'tw'},
                    { name: 'English', id: 'lagnuage_en', value: 'en'}
                ]

                const NODE_TEXT = '語言設定 Language'

                this.init_opened_layers = [NODE_TEXT]

                this.init_items = [{
                    icon: '',
                    layer1: true,
                    node: true,
                    name: NODE_TEXT,
                    radio_name: `${NODE_TEXT}_root`,
                    children: LANGUAGE_OPTIONS.map(language_option => {
                        return {
                            ...language_option, 
                            ...{
                                data_group: 'language',
                                layer1: false,
                                node: false,
                                type: "cross_type_single_radio",
                            }
                        }
                    })
                }]

                this.checked_selectors = LANGUAGE_OPTIONS.reduce((accum, option) => {
                    return {
                        ...accum, 
                        ...{
                            [option.id]: {
                                id: option.id,
                                checked: option.value === this.language
                            }
                        }
                    }
                }, {})
            },

            change_language(id) {
                const language = id.split('_')[1]
                i18n.locale = language;
                this.set_language(language);
                localStorage.setItem('locale', language)
            },
        },
	}
</script>

<style lang="scss" scoped>
    .language_treeview {
        height: calc(100vh - 30px);
        background: #454d66;
        overflow-y: auto;
    }

    .menu_ctrl {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: var(--base-gray-darken);
        padding: 3px;
        touch-action: none;
    }

    .text {
        color: #b3b7c4;
    }
</style>